<template>
    <div class="article">
        <el-row type="flex" justify="center">
            <el-col :md="14" :sm="18" :xs="18" >
                
                <div
                  class="ql-container ql-snow"
                  ref="editor"
                  style="min-height: 100px;border: none;"
                >
                <h5 style="font-weight: bold;">{{article.title}}</h5>
                <div style="font-size: 12px;color:#000000;">发表日期：{{article.inputTime}}</div>
                  <div class="ql-editor" v-html='article.content'></div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    export default{
        data(){
            return{
                article:{},
                aid:0,
                show:false
            }
        },
        created() {
            let aid = this.$route.query.id;
            this.getArticle(aid)
        },
        filters:{
            formatHtml:function(value){
                if (value) {
                    // 去除转义符号\"
                    value = value.replace(/"/g, '');
                  }
                  return value;
            }
        },
        methods:{
            getArticle(id){
                this.$axios.get('https://www.drmums.com/article/info/'+id).then(
                //this.$axios.get('http://localhost:8080/article/info/'+id).then(
                  res=>{
                      this.article = res.data.data
                      document.title = this.article.title
                })
            }
        }
        
    }
</script>

<style lang="scss">
    .article{
        
            @media only screen and (max-width:992px){
                margin-top: 100px;
            }
            margin-top: 150px;
    }
</style>